 <template>
     <div class="container-fuild analytics-box">
         <div id="analytics" class="container">
             <div class="analyticsDiv">
                 <a v-bind:href="advertiserUrl" target="_blank" v-if="advertiserImageUrl">
                     <img class="pull-left logoImg" v-bind:src="advertiserImageUrl"/>
                 </a>
                 <div class="breakupSummary filtered">
                     <div>
                         <span>{{ totalReviewCountFiltered }}</span>
                         <span>Reviews</span>
                     </div>
                     <div>
                         <span>{{ totalReviewCountApproved }}</span>
                         <span>Approved</span>
                     </div>
                     <div>
                         <span>{{ totalReviewCountPending }}</span>
                         <span>Pending</span>
                     </div>
                     <div>
                         <span>{{ totalReviewCountRejected }}</span>
                         <span>Rejected</span>
                     </div>
                     <div>
                         <span class="rating">{{ averageOverallRating.toFixed(1) }}</span>
                         <span class="maxRating">/5</span>
                         <div class="sm">Star Rating Average</div>
                     </div>
                 </div>
                 <div class="analyticsDetails">
                     <div class="starDiv pull-left">
                         <ul class="starAnalyticsUl list-unstyled">
                             <li v-if="fiveStarCount">
                                 <span class="barTitle">5 Star</span>
                                 <div class="barDiv">
                                <span class="barValueDiv"
                                      v-bind:style='{"width" :  getWidth(fiveStarCount)+"px" }'>
                                </span>
                                     <span class="percent">
                                    {{ getPercent(fiveStarCount, 0) }}%
                                </span>
                                 </div>
                             </li>
                             <li v-if="fourStarCount">
                                 <span class="barTitle">4 Star</span>
                                 <div class="barDiv">
                                <span class="barValueDiv"
                                      v-bind:style='{"width" : getWidth(fourStarCount)+"px" }'>
                                </span>
                                     <span class="percent">
                                    {{ getPercent(fourStarCount) }}%
                                </span>
                                 </div>
                             </li>
                             <li v-if="threeStarCount">
                                 <span class="barTitle">3 Star</span>
                                 <div class="barDiv">
                                <span class="barValueDiv"
                                      v-bind:style='{"width" : getWidth(threeStarCount)+"px" }'>
                                </span>
                                     <span class="percent">
                                    {{ getPercent(threeStarCount) }}%
                                </span>
                                 </div>
                             </li>
                             <li v-if="twoStarCount">
                                 <span class="barTitle">2 Star</span>
                                 <div class="barDiv">
                                <span class="barValueDiv"
                                      v-bind:style='{"width" : getWidth(twoStarCount)+"px" }'>
                                </span>
                                     <span class="percent">
                                    {{ getPercent(twoStarCount) }}%
                                </span>
                                 </div>
                             </li>
                             <li v-if="oneStarCount">
                                 <span class="barTitle">1 Star</span>
                                 <div class="barDiv">
                                <span class="barValueDiv"
                                      v-bind:style='{"width" : getWidth(oneStarCount)+"px" }'>
                                </span>
                                     <span class="percent">
                                    {{ getPercent(oneStarCount) }}%
                                </span>
                                 </div>
                             </li>
                         </ul>
                     </div>
                     <div class="text-center pull-left recommendedDiv" v-if="percentageRecommendLender">
                         <div class="baseDiv">
                             <div class="deduct right">
                                 <div v-if="percentageRecommendLender <= 50" class="fill"></div>
                                 <div class="fill" v-if="percentageRecommendLender > 50"
                                      v-bind:style='{"transform:rotate" : 180 - ((100 - percentageRecommendLender) * 3.6)+"deg" }'>
                                 </div>
                             </div>
                             <div class="deduct left" v-if="percentageRecommendLender <= 50">
                                 <div v-bind:style='{"transform:rotate" : (percentageRecommendLender * 3.6)+"deg" }'>
                                 </div>
                             </div>
                             <div id="percent">
                                 {{ percentageRecommendLender.toFixed(0) }}%
                             </div>
                         </div>
                         <span class="show">Recommended</span>
                     </div>
                     <div class="aspectsDiv pull-right">
                         <ul class="aspectAnalyticsUl  list-unstyled">
                             <li v-if="averageProfessionalism">
                                 <span class="barTitle">Professionalism</span>
                                 <div class="barDiv">
                                <span class="barValueDiv bar1"
                                      v-bind:style='{"width" : (averageProfessionalism * 224 / 5)+"px" }'>
                                </span>
                                     <span class="aspectRating">{{ averageProfessionalism.toFixed(1) }}</span>
                                 </div>
                             </li>
                             <li v-if="averageKnowledge">
                                 <span class="barTitle">Knowledge</span>
                                 <div class="barDiv">
                                <span class="barValueDiv bar2"
                                      v-bind:style='{"width" : (averageKnowledge * 224 / 5)+"px" }'>
                                </span>
                                     <span class="aspectRating">{{ averageKnowledge.toFixed(1) }}</span>
                                 </div>
                             </li>
                             <li v-if="averageResponsivness">
                                 <span class="barTitle">Responsiveness</span>
                                 <div class="barDiv">
                                <span class="barValueDiv bar3"
                                      v-bind:style='{"width" : (averageResponsivness * 224 / 5)+"px" }'>
                                </span>
                                     <span class="aspectRating">{{ averageResponsivness.toFixed(1) }}</span>
                                 </div>
                             </li>
                             <li v-if="averageLevelOfService">
                                 <span class="barTitle">Level of Service</span>
                                 <div class="barDiv">
                                <span class="barValueDiv bar4"
                                      v-bind:style='{"width" : (averageLevelOfService * 224 / 5)+"px" }'>
                                </span>
                                     <span class="aspectRating">{{ averageLevelOfService.toFixed(1) }}</span>
                                 </div>
                             </li>
                             <li v-if="percentageRatesHonored">
                                 <span class="barTitle">Rates Honored%</span>
                                 <div class="barDiv">
                                <span class="barValueDiv bar4"
                                      v-bind:style='{"width" : (percentageRatesHonored * 224 / 100)+"px" }'>
                                </span>
                                 <span class="aspectRating">
                                    {{ percentageRatesHonored }}%
                                </span>
                                 </div>
                             </li>
                         </ul>
                     </div>
                 </div>
             </div>
         </div>
     </div>
</template>

<script>
export default {
    name: "reviews-analytics",
    props: {
        'advertiserUrl': {
          type: String,
          required: false
        },
        'advertiserImageUrl': {
            type: String,
            required: false
        },
        'totalReviewCountFiltered': {
            type: Number,
            required: true
        },
        'totalReviewCountApproved': {
            type: Number,
            required: true
        },
        'totalReviewCountPending': {
            type: Number,
            required: true
        },
        'totalReviewCountRejected': {
            type: Number,
            required: true
        },
        'averageOverallRating': {
            type: Number,
            required: true
        },
        'fiveStarCount': {
            type: Number,
            required: false,
            default: null
        },
        'fourStarCount': {
            type: Number,
            required: false,
            default: null
        },
        'threeStarCount': {
            type: Number,
            required: false,
            default: null
        },
        'twoStarCount': {
            type: Number,
            required: false,
            default: null
        },
        'oneStarCount': {
            type: Number,
            required: false,
            default: null
        },
        'percentageRecommendLender': {
            type: Number,
            required: false,
            default: null
        },
        'averageProfessionalism': {
            type: Number,
            required: false,
            default: null
        },
        'averageKnowledge': {
            type: Number,
            required: false,
            default: null
        },
        'averageResponsivness': {
            type: Number,
            required: false,
            default: null
        },
        'averageLevelOfService': {
            type: Number,
            required: false,
            default: null
        },
        'percentageRatesHonored': {
            type: Number,
            required: false,
            default: null
        },
    },
    data: () => {
        return {
            divider: 1
        };
    },
    computed: {
    },
    methods: {
        getPercent: function(val) {
            if(!val) return null;

            return (val * 100 / this.totalReviewCountFiltered).toFixed(0);
        },
        getWidth: function(val) {
            if(!val) return null;

            return val * 224 / this.totalReviewCountFiltered;
        },
    },
};
</script>
